var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconBack48Line = function SvgIconBack48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.55 37.2 17.4 26.05c-.55-.55-.85-1.28-.85-2.05 0-.77.3-1.5.85-2.05L28.55 10.8l2.4 2.4L20.15 24l10.8 10.8-2.4 2.4Z",
    fill: "current"
  })));
};
export default SvgIconBack48Line;